import React, {memo, useState} from 'react';
import Search from "../Components/Common/Search";
import FAQVideosList from "../Components/FAQ/FAQVideosList";
import Roles from "../Config/Roles";
import {Col, Container, Row} from "react-bootstrap";

function FAQ() {

    /**
     * The video data that we want to feed to FAQ Page. Each video data has its headline,
     * the URL where the video is hosted and respective visibility permissions.
     * @type {[{visible: string[], name: string, URL: string}, {visible: (string)[], name: string, URL: string},
     * {visible: string[], name: string, URL: string}, {visible: (string)[], name: string, URL: string},
     * {visible: (string)[], name: string, URL: string}, null, null, null]}
     */
    const videoData = [
        {
            name: 'Wo finde ich meine Analysen?',
            URL: "https://vimeo.com/535899310",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Wie melde ich mich bei Handwai an?',
            URL: "https://vimeo.com/535899365",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST, Roles.CALCULATOR]
        },
        {
            name: 'Wie lege ich weitere Mitarbeiter an?',
            URL: "https://vimeo.com/535899420",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        },
        {
            name: 'Erste Anmeldung bei Handwai',
            URL: "https://vimeo.com/535899524",
            visible: [Roles.ADMIN, Roles.ANALYST, Roles.SUPER_ADMIN, Roles.CALCULATOR]
        },
        {
            name: 'Wie stelle ich ein LV zur Analyse ein?',
            URL: "https://vimeo.com/535899573",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST, Roles.CALCULATOR]
        },
        {
            name: 'Wie ändere ich mein Passwort?',
            URL: "https://vimeo.com/535899625",
            visible: [Roles.ADMIN, Roles.SUPER_ADMIN, Roles.ANALYST, Roles.CALCULATOR]
        },
        {
            name: 'Ich habe mein Passwort vergessen, was tun?',
            URL: "https://vimeo.com/535899680",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST, Roles.CALCULATOR]
        },
        {
            name: 'Welche Rechte hat der Mitarbeiter?',
            URL: "https://vimeo.com/535899760",
            visible: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ANALYST]
        }

    ];

    /**
     * searchData is used to capture the user input for search functionality.
     */
    const [searchData, setSearchData] = useState('');

    /**
     * handleSearchChange updates the searchData value for each user input i.e., captured by event.
     * @param event
     */
    const handleSearchChange = (event) => {
        setSearchData(event.target.value);
    }

    /**
     * filteredVideos maintains the list of videos matching the searchData
     * @type {({visible: string[], name: string, URL: string}|null)[]}
     */
    const filteredVideos = videoData.filter(video => (
        video.name.toLowerCase().includes(searchData.toLowerCase())
    ));

    return (
        <div style={{color: 'white'}}>

            <br/>

            <div className="handwai-dark" style={borerStyle}>
                <br/>

                <Container fluid>
                    <Row>
                        <Col sm={1} className="handwai-text-label-normal">Suchen</Col>
                        <Col style={searchStyle}><Search placeholder="Suchen"
                                                         handleChange={handleSearchChange}/></Col>
                    </Row>

                    <br/> <Row>
                    <FAQVideosList videoData={filteredVideos}/>
                </Row>
                </Container>
            </div>

        </div>
    )
}

const searchStyle = {
    marginLeft: -80
}

const borerStyle = {
    margin: 20,
    padding: 20,
    paddingBottom: 50,
    color: "white"
}

export default memo(FAQ);